import React from "react";

function VideoPause() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="47"
      viewBox="0 0 47 47"
    >
      <g id="Pause_Icon" data-name="Pause Icon" transform="translate(0 0)">
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="23.5"
          cy="23.5"
          r="23.5"
          transform="translate(0 0)"
          opacity="0.7"
        />
        <g
          id="Icon_ion-ios-pause"
          data-name="Icon ion-ios-pause"
          transform="translate(17.281 15.392)"
        >
          <path
            id="Path_19896"
            data-name="Path 19896"
            d="M12.684,23.147H9.415A.412.412,0,0,1,9,22.737V7.16a.412.412,0,0,1,.415-.41h3.269a.412.412,0,0,1,.415.41V22.737A.412.412,0,0,1,12.684,23.147Z"
            transform="translate(-9 -6.75)"
            fill="#fff"
          />
          <path
            id="Path_19897"
            data-name="Path 19897"
            d="M25.059,23.147H21.79a.412.412,0,0,1-.415-.41V7.16a.412.412,0,0,1,.415-.41h3.269a.412.412,0,0,1,.415.41V22.737A.412.412,0,0,1,25.059,23.147Z"
            transform="translate(-12.357 -6.75)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default VideoPause;
